// extracted by mini-css-extract-plugin
module.exports = {"kohHorizontalruleBlock":"FullWidthBanner_kohHorizontalruleBlock__w4hOg"};